import React from 'react';
import { fmtM, fmtT, fmtN } from './theme';

export const KPICards = ({ kpi, metric = 'val' }) => {
  if (!kpi) return null;

  const cards = [
    { label: 'SHIPMENTS', value: fmtN(kpi.shipments), sub: 'consignments' },
    { label: 'EXPORTERS', value: fmtN(kpi.exporters), sub: 'unique shippers' },
    { label: 'BUYERS', value: fmtN(kpi.buyers), sub: 'unique importers' },
  ];

  return (
    <div className="grid grid-cols-3 gap-3" data-testid="kpi-cards">
      {cards.map((c) => (
        <div key={c.label} className="bg-dash-panel border border-dash-line rounded-xl p-4">
          <div className="text-[10px] font-mono uppercase tracking-wider text-dash-mut">{c.label}</div>
          <div className="text-2xl font-mono font-bold text-dash-ink mt-1">{c.value}</div>
          <div className="text-[11px] font-mono text-dash-mut mt-0.5">{c.sub}</div>
        </div>
      ))}
    </div>
  );
};
